import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Avatar } from '@material-ui/core';
export const MAvatar = forwardRef(({ color = 'default', children, sx, ...other }, ref) => {
    const theme = useTheme();
    if (color === 'default') {
        return (_jsx(Avatar, Object.assign({ ref: ref, sx: sx }, other, { children: children }), void 0));
    }
    return (_jsx(Avatar, Object.assign({ ref: ref, sx: {
            fontWeight: theme.typography.fontWeightMedium,
            color: theme.palette[color].contrastText,
            backgroundColor: theme.palette[color].main,
            ...sx,
        } }, other, { children: children }), void 0));
});
//# sourceMappingURL=MAvatar.js.map